import React from 'react';

function About() {
    return (
        <section className="section about">
            <h2>Who We Are</h2>
            <p>
                At ScaleNest, we specialize in building software and digital solutions to help small
                and local businesses grow. Whether you're running a shop, service, or local brand —
                we can help take it online with ease and affordability.
            </p>
        </section>
    );
}

export default About;
